import { render, staticRenderFns } from "./NotificationMass.vue?vue&type=template&id=1fdf66ca"
import script from "./NotificationMass.vue?vue&type=script&lang=js"
export * from "./NotificationMass.vue?vue&type=script&lang=js"
import style0 from "./NotificationMass.vue?vue&type=style&index=0&id=1fdf66ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports